  const $quantityFormInput = $('.product-info-wrap [name=quantity].quantity-selector__input');
$(document).on("change",".product-info-wrap [name=quantity].quantity-selector__input", function() {

    const price = parseFloat($('.total-price-wrapper .total-price').data('price') / 100);
    const quantity = parseInt($(this).val(), 10) || 0;
    
    setTimeout(function() {
      $('.total-price-wrapper .total-price').text(`$${(quantity * price).toFixed(2)}`);
    }, 0);
});


//   document.addEventListener("DOMContentLoaded", function () {
//     const quantitySelectors = document.querySelectorAll(".quantity-selector");

//     quantitySelectors.forEach(selector => {
//       const minusBtn = selector.querySelector(".quantity-selector__minus-btn");
//       const plusBtn = selector.querySelector(".quantity-selector__plus-btn");
//       const quantityInput = selector.querySelector(".quantity-selector__input");

//       minusBtn.addEventListener("click", () => {

//          let currentValue = parseInt(quantityInput.value);
//           let updatedValue = currentValue - 1;

//             if (updatedValue <= 0) {
//               updatedValue = 0;
//             }
//             console.log(updatedValue);
//               quantityInput.value = updatedValue;
            
//           quantityInput.dispatchEvent(new Event('change')); // optional: to trigger form logic
//       });

//       plusBtn.addEventListener("click", () => {
//         let currentValue = parseInt(quantityInput.value);
// let updatedValue = currentValue + 1;
//         console.log(updatedValue);
//         quantityInput.value = updatedValue;
//         quantityInput.dispatchEvent(new Event('change')); // optional: to trigger form logic
//       });
//     });
//   });
$(document).ready(function () {

    $(document).on("click","cart-drawer .quantity-selector__minus-btn", function () {
       const $input = $(this).parents(".quantity-selector").find(".quantity-selector__input");
      let currentValue = parseInt($input.val()) || 0;
      let updatedValue = currentValue - 1;

      if (updatedValue <= 0) {
        updatedValue = 0;
      }

      console.log(updatedValue);
      $input.val(updatedValue).trigger("change");
    });

    $(document).on("click","cart-drawer .quantity-selector__plus-btn", function () {
       const $input = $(this).parents(".quantity-selector").find(".quantity-selector__input");
      
      let currentValue = parseInt($input.val()) || 0;
      let updatedValue = currentValue + 1;

      console.log(updatedValue);
      $input.val(updatedValue).trigger("change");
    });
});
